/*
  This component renders a ListWithDividers, with SimilarBook items.

  Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
*/

import { PropTypes } from "react";
import ListWithDividers from "../list_with_dividers";
import SimilarBook from "./similar_book";

const SimilarBooksList = ({ similarBooks }) => (
  <ListWithDividers ItemComponentType={SimilarBook}
                    items={similarBooks} />
);

SimilarBooksList.propTypes = {
  similarBooks: PropTypes.array.isRequired,
};

export default SimilarBooksList;
